import { render, staticRenderFns } from "./ClienteProveedorPantalla.vue?vue&type=template&id=0928ff5a&"
import script from "./ClienteProveedorPantalla.vue?vue&type=script&lang=ts&"
export * from "./ClienteProveedorPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports